// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 0;
    font-size: 4rem;
    color: gold;
  }

  hr {
    margin-top: 0;
    width: 100%;
    border: 3px solid #ffffff50;
    border-radius: 2px;
  }

  &>div {
    width: 100%;
    display: flex;

    button {
      border: 0;
      background: transparent;
      color: gold;
      outline: 3px solid gold;
      font: inherit;
      font-weight: 500;
      font-size: 1.1rem;
      padding: 15px 0;
      border-radius: 5px;
      cursor: pointer;

      flex: 1;

      &+button {
        margin-left: 1rem;
      }

      &:hover {
        outline: 5px solid #ffffff50;
      }
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/home/home.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;;IAEb;MACE,SAAS;MACT,uBAAuB;MACvB,WAAW;MACX,uBAAuB;MACvB,aAAa;MACb,gBAAgB;MAChB,iBAAiB;MACjB,eAAe;MACf,kBAAkB;MAClB,eAAe;;MAEf,OAAO;;MAEP;QACE,iBAAiB;MACnB;;MAEA;QACE,4BAA4B;MAC9B;IACF;EACF;AACF","sourcesContent":[".home-container {\n  color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  h1 {\n    margin-bottom: 0;\n    font-size: 4rem;\n    color: gold;\n  }\n\n  hr {\n    margin-top: 0;\n    width: 100%;\n    border: 3px solid #ffffff50;\n    border-radius: 2px;\n  }\n\n  &>div {\n    width: 100%;\n    display: flex;\n\n    button {\n      border: 0;\n      background: transparent;\n      color: gold;\n      outline: 3px solid gold;\n      font: inherit;\n      font-weight: 500;\n      font-size: 1.1rem;\n      padding: 15px 0;\n      border-radius: 5px;\n      cursor: pointer;\n\n      flex: 1;\n\n      &+button {\n        margin-left: 1rem;\n      }\n\n      &:hover {\n        outline: 5px solid #ffffff50;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
